import { render, staticRenderFns } from "./payer-address.vue?vue&type=template&id=731e0892"
import script from "./payer-address.vue?vue&type=script&lang=js"
export * from "./payer-address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports